import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
import React from 'react'

function Phone2(props: SvgIconProps) {
  return (
    <SvgIcon
      fill="none"
      height="150"
      viewBox="0 0 197 150"
      width="197"
      {...props}
    >
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint0_linear_41575_204098"
          x1="263.196"
          x2="4.88744"
          y1="26.4836"
          y2="33.3554"
        >
          <stop offset="0.0222184" stopColor="white" />
          <stop offset="0.76744" stopColor="#F5F8FF" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint1_linear_41575_204098"
          x1="85.7305"
          x2="122.239"
          y1="66.5552"
          y2="142.061"
        >
          <stop stopColor="#F0F5FD" />
          <stop offset="1" stopColor="#C4D1ED" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint2_linear_41575_204098"
          x1="127"
          x2="112.937"
          y1="60.8896"
          y2="86.7384"
        >
          <stop stopColor="#F0F5FD" />
          <stop offset="1" stopColor="#C4D1ED" />
        </linearGradient>
      </defs>
      <path
        d="M133.407 149.89L37.0805 149.89C37.0805 149.89 1.52588e-05 149.89 1.52588e-05 102.257C1.52588e-05 54.6245 52.0901 74.5698 100.701 19.5952C142 -27.1102 197 19.3552 197 58.3899C197 112.924 142.243 109.475 133.407 149.89Z"
        fill="url(#paint0_linear_41575_204098)"
      />
      <rect
        fill="url(#paint1_linear_41575_204098)"
        height="140"
        rx="10"
        width="73.5897"
        x="62"
        y="9.88965"
      />
      <rect
        height="137.6"
        rx="8.77592"
        stroke="#E1E7F5"
        strokeWidth="2.4"
        width="71.1897"
        x="63.2"
        y="11.0896"
      />
      <path
        d="M85.333 11.6846H112.256V11.949C112.256 13.7855 110.767 15.2743 108.931 15.2743H88.6583C86.8218 15.2743 85.333 13.7855 85.333 11.949V11.6846Z"
        fill="#E1E7F5"
      />
      <rect
        fill="white"
        height="1.79487"
        rx="0.897436"
        width="25.1282"
        x="86.2314"
        y="140.915"
      />
      <rect fill="white" height="14" width="38" x="112" y="69.8896" />
      <path
        d="M150.2 55.8896H103.8C101.16 55.8896 99 58.0496 99 60.6896V103.89L108.6 94.2896H150.2C152.84 94.2896 155 92.1297 155 89.4897V60.6896C155 58.0496 152.84 55.8896 150.2 55.8896ZM119.8 75.0896C119.8 76.4151 118.725 77.4896 117.4 77.4896C116.075 77.4896 115 76.4151 115 75.0896C115 73.7642 116.075 72.6896 117.4 72.6896C118.725 72.6896 119.8 73.7642 119.8 75.0896ZM129.4 75.0896C129.4 76.4151 128.325 77.4896 127 77.4896C125.675 77.4896 124.6 76.4151 124.6 75.0896C124.6 73.7642 125.675 72.6896 127 72.6896C128.325 72.6896 129.4 73.7642 129.4 75.0896ZM139 75.0896C139 76.4151 137.925 77.4896 136.6 77.4896C135.275 77.4896 134.2 76.4151 134.2 75.0896C134.2 73.7642 135.275 72.6896 136.6 72.6896C137.925 72.6896 139 73.7642 139 75.0896Z"
        fill="url(#paint2_linear_41575_204098)"
      />
    </SvgIcon>
  )
}

export default Phone2
